import React, { ReactElement } from 'react'
import { useRouter } from 'next/router'

import { RecipePage } from '@mindfulchefuk/components/pages/RecipePage/RecipePage'
import { recipeSearchPageFilterDefaults } from '@mindfulchefuk/config/recipeSearchPageFilterDefaults'
import { SearchPage } from '@mindfulchefuk/components/pages/SearchPage/SearchPage'

export default function HealthyRecipesPage(): ReactElement {
  const {
    query: { healthyRecipesPage, deliveryDate, portionCount },
  } = useRouter()

  const filterConfig = recipeSearchPageFilterDefaults.healthyRecipes.find(
    ({ slug }) => slug === healthyRecipesPage
  )

  if (filterConfig) {
    return <SearchPage slug={filterConfig.slug} filter={filterConfig.filter} />
  }

  return (
    <RecipePage
      slug={healthyRecipesPage as string}
      deliveryDate={deliveryDate as string}
      portionCount={portionCount as string}
    />
  )
}

export { getStaticPathsHelper as getStaticPaths } from '@mindfulchefuk/features/CMS/services/getStaticData'
export { getStaticGlobalContent as getStaticProps } from '@mindfulchefuk/features/CMS/services/getStaticData'
